import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl04 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".black{fill:currentColor" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Command_04",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Document",
			className: "black",
			d: "M34.41,31.71l2.27-2.27h1.14c.53,0,.96.43.96.96v.35c0,.53-.43.96-.96.96h-3.41ZM37.82,33.98h-5.68l-2.27,2.27h7.94c.53,0,.96-.43.96-.96v-.35c0-.53-.43-.96-.96-.96ZM41.17,24.95v20.37c0,.07-.06.13-.13.13h-18.14c-.07,0-.13-.06-.13-.13v-1.96l-2,2c.02,1.16.96,2.1,2.13,2.1h18.14c1.18,0,2.13-.96,2.13-2.13v-22.37l-2,2ZM18.96,43.92c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l2.52-2.52v-21.59c0-1.18.96-2.13,2.13-2.13h13.33c.57,0,1.1.22,1.51.62l3.07,3.05,1.4-1.4c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-1.4,1.4-1.41,1.41h0l-.3.3h0l-2,2h0l-4.67,4.67h0l-2.27,2.27h0l-2.27,2.27h0l-2.27,2.27h0l-4.28,4.28h0s-2,2-2,2h0s-1.1,1.1-1.1,1.1c-.2.2-.45.29-.71.29ZM36.37,22.64c0,.07.06.13.13.13h1.18l1.71-1.71-3.03-3.01v4.59ZM22.77,37.7l2.4-2.4s0,0,0,0v-.35c0-.53.43-.96.96-.96h.36l2.27-2.27h-2.63c-.53,0-.96-.43-.96-.96v-.35c0-.53.43-.96.96-.96h4.89l4.79-4.79c-.84-.29-1.44-1.08-1.44-2.01v-4.67h-11.47c-.07,0-.13.06-.13.13v19.59ZM37.82,38.51h-10.21l-2.06,2.06c.16.12.35.21.58.21h11.69c.53,0,.96-.43.96-.96v-.35c0-.53-.43-.96-.96-.96Z"
		})
	})]
});
export default SvgAppIcBefehl04;
